import React from "react";
import { ReviewItem, ReviewItemProps } from "../Components/ReviewItem";
import { LangItem } from "../core/Helpers/LangItem";
import { ICONS } from "../../Constants/icons";
import {LButton} from "../Components/LButton";

type ReviewListProps = {
    dataList?: Array<ReviewItemProps>;
};

type ReviewListState = {
    visibleCount: number;
};

class ReviewList extends React.Component<ReviewListProps, ReviewListState> {
    listReviews: Array<ReviewItemProps>;

    constructor(props: ReviewListProps) {
        super(props);
        this.state = { visibleCount: 6 };

        this.listReviews = this.listReviews = [
            {
                id: 1,
                name: "James Caldwell",
                description: 'Full frame-off restoration – Mercedes-Benz 220SEL (1972)',
                avatar: ICONS.avatar,
                date: "March 15",
                rating: 5,
                content:
                    "I brought them a rusted 220SEL shell and they returned a showstopper. The attention to historical accuracy and mechanical precision was incredible. It feels like stepping back into the '70s — but better.",
            },
            {
                id: 2,
                name: "Hans Schneider",
                description: 'Modernization + comfort upgrade – Mercedes G-Class W463 (2004)',
                avatar: ICONS.avatar,
                date: "April 10",

                rating: 5,
                content:
                    "We needed more than just restoration — we wanted modern comfort without losing that iconic G-Class soul. Chobal's team balanced performance, safety and style perfectly. It drives like a dream!",
            },
            {
                id: 3,
                name: "Michael Thorne",
                description: 'Engine rebuild & performance tuning – PUCH 300GDT',
                avatar: ICONS.avatar,
                date: "May 5",
                rating: 5,
                content:
                    "These guys know diesel engines inside out. My PUCH came back stronger, cleaner, and more reliable than ever. Smooth communication and world-class execution",
            },
            {
                id: 4,
                name: "Elena Ricci",
                description: 'Complete bodywork and repaint – Mercedes W460',
                avatar: ICONS.avatar,
                date: "June 20",
                rating: 5,
                content:
                    "I was nervous trusting someone abroad with my father’s W460. But Chobal Classic made it feel personal. They shared updates, photos, and even helped with logistics. The result? Absolutely flawless.",
            },
            {
                id: 5,
                name: "Thomas Becker",
                description: 'Custom interior rebuild – Mercedes G500 Cabrio',
                avatar: ICONS.avatar,
                date: "July 30",
                rating: 4,
                content:
                    "The leatherwork, stitching, and detailing are on another level. Luxury feel without losing authenticity. Worth every franc!",
            },
            {
                id: 6,
                name: "Pieter Bakker",
                description: 'Rescue project – neglected G-Class barn find',
                avatar: ICONS.avatar,
                date: "August 12",
                rating: 5,
                content:
                    "What looked like scrap in a barn turned into a collector’s piece. Chobal’s team didn’t just restore — they revived a legend.",
            },
            {
                id: 7,
                name: "Sarah Jensen",
                description: 'Partial restoration + off-road upgrade – G-Class Professional',
                avatar: ICONS.avatar,
                date: "April 10",
                rating: 5,
                content:
                    "Now I can take my G off-road without fear, and still turn heads in the city. The balance between ruggedness and elegance is perfect. Fantastic job, team!",
            },
            {
                id: 8,
                name: "Markus Helbig",
                description: 'Collector’s restoration – Mercedes 300SL (classic revival)',
                avatar: ICONS.avatar,
                date: "March 15",
                rating: 5,
                content:
                    "Even though this was a replica, they treated it like a museum piece. Impressive respect for design and engineering. I proudly display it at events now.",
            },
            {
                id: 9,
                name: "Annette Schulz",
                description: 'Long-distance customer – Remote coordination (Germany > Czechia)',
                avatar: ICONS.avatar,
                date: "June 20",
                rating: 5,
                content:
                    "We never met in person — and still, I felt fully involved. They sent regular progress reports, videos, and were incredibly responsive. I trusted them completely — and they delivered.",
            },
            {
                id: 10,
                name: "Omar Al-Saleh",
                description: 'G320 restomod for Middle East client',
                avatar: ICONS.avatar,
                date: "July 30",
                rating: 5,
                content:
                    "My G320 was upgraded inside and out — engine, interior, electronics. All top-tier. Chobal Classic is a hidden gem in Europe, and I will be sending more cars their way.",
            },
            {
                id: 11,
                name: "David Steiner",
                description: 'Classic Mercedes Restoration – G-Class W460 (1989)',
                avatar: ICONS.avatar,
                date: "March 15",
                rating: 5,
                content:
                    "I couldn't believe my eyes when I saw my restored G-Class. Every detail was brought back to life with precision and passion. Chobal Classic Restoration exceeded all expectations — true craftsmanship!",
            },
            {
                id: 12,
                name: "Anna Dupont",
                description: 'Retro Car Project – Mercedes 190SL (1963)',
                avatar: ICONS.avatar,
                date: "April 10",
                rating: 4,
                content:
                    "The team at Chobal turned my forgotten classic into a masterpiece. Professional, transparent, and dedicated — I highly recommend their work to any vintage car enthusiast.",
            },
            {
                id: 13,
                name: "Jürgen Möller,",
                description: 'Full Restoration – Mercedes W111 Coupe',
                avatar: ICONS.avatar,
                date: "April 10",
                rating: 5,
                content:
                    "From the first consultation to the final delivery, the communication was excellent and the result… simply breathtaking. These guys are artists, not just mechanics.",
            },
            {
                id: 14,
                name: "Guido Matthes",
                description: 'PUCH 300GDT',
                avatar: ICONS.avatar,
                date: "March 15",
                rating: 5,
                content:
                    "I’ve had several restoration experiences, but none like this. The quality, care, and attention to detail were unmatched. This was more than a service — it was a collaboration.",
            },
            {
                id: 15,
                name: "Emily Novak",
                description: 'Custom Modernization – Mercedes G500 (2002)',
                avatar: ICONS.avatar,
                date: "June 20",
                rating: 5,
                content:
                    "We asked for modern performance with a vintage soul — and they delivered exactly that. Chobal Classic Restoration brought our vision to life perfectly.",
            },
        ];
    }

    componentDidUpdate(prevProps: ReviewListProps) {
        if (prevProps.dataList !== this.props.dataList) {
            this.setState({ visibleCount: 6 });
        }
    }

    loadMore = () => {
        this.setState((prevState, props) => {
            const total = (props.dataList?.length ?? this.listReviews.length);
            return {
                visibleCount: Math.min(total, prevState.visibleCount + 6),
            };
        });
    };

    render() {
        const dataList = this.props.dataList || this.listReviews;
        const { visibleCount } = this.state;
        const canLoadMore = visibleCount < dataList.length;

        return (
            <div className="review-list">
                <div className="reviews-title">
                    <LangItem for="REVIEWS" />
                </div>

                <div className="review-list-items">
                    {dataList.slice(0, visibleCount).map((review) => (
                        <ReviewItem
                            key={review.id}
                            id={review.id}
                            name={review.name}
                            description={review.description}
                            avatar={review.avatar}
                            date={review.date}
                            rating={review.rating}
                            content={review.content}
                        />
                    ))}
                </div>

                {canLoadMore && (
                    <div className="review-list-load-more-wrapper">
                        <LButton
                            title='Load more...'
                            iconOrder={1}
                            type='suit'
                            customStyle='connect-button'
                            onClick={this.loadMore}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export { ReviewList };
